import { Injectable } from '@angular/core';
import { IApi, GenericApi } from '../../common/ng-api';
import { Http } from '@angular/http';
import { Invoice } from '../../models/bap/invoice.model';

@Injectable()
export class InvoiceService {

  invoices: IApi<Invoice>;

  constructor(private http: Http) {
    const baseApi = 'bap';
    this.invoices = new GenericApi<Invoice>('invoices', http, baseApi);
  }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/services/bap/invoice.service.ts